import React, { Component } from 'react'
import LinkedInput from '../inputs/LinkedInput'
import CollapsableBox from './CollapsableBox'

class AttributesBox extends Component {
  constructor (props) {
    super(props)
    this.state = {
      attributes: null,
      editable: false
    }
  }
  componentWillReceiveProps (props) {
    this.setAttributes(props)
  }
  componentDidMount () {
    this.setAttributes(this.props)
  }
  setAttributes (props) {
    this.setState({attributes: props.attributes})
  }
  save () {
    this.props.save(this.state.attributes)
    this.setState({editable: false})
  }
  render () {
    if (!this.state.attributes) return false
    return (
      <CollapsableBox
        cols='12'
        icon='tags'
        title='Attributes'
        identifier={window.location.hash}
        buttons={[
          { icon: 'fa-save', event: () => this.save(), hidden: !this.state.editable },
          { icon: 'fa-edit', event: () => this.setState({editable: true}), hidden: this.state.editable }
        ]}>
        <div className='row'>
          {Object.keys(this.state.attributes).map(attribute => {
            return (
              <div className='col-md-3 form-group' key={attribute}>
                <label>{attribute}</label>
                <LinkedInput context={this} path={'attributes.' + attribute} editable={this.state.editable} />
              </div>
            )
          })}
        </div>
      </CollapsableBox>
    )
  }
}
export default AttributesBox



// WEBPACK FOOTER //
// ./src/components/basic/containers/AttributesBox.js